var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotificationActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 45.834,
    height: 50,
    viewBox: "0 0 45.834 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "notification-active",
    transform: "translate(-6 -4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_19111",
    "data-name": "Trazado 19111",
    d: "M28.506,21.011A8.506,8.506,0,1,0,20,12.506,8.5,8.5,0,0,0,28.506,21.011Z",
    transform: "translate(14.822)",
    fill: "#ffb81c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_19112",
    "data-name": "Trazado 19112",
    d: "M43.422,33.167A4.175,4.175,0,0,1,39.264,29V26.917a2.079,2.079,0,1,0-4.158,0V29a8.322,8.322,0,0,0,8.316,8.333V41.5H10.158V37.333A8.322,8.322,0,0,0,18.474,29V20.667a8.322,8.322,0,0,1,8.316-8.333,4.167,4.167,0,1,0-4.158-4.167V8.9a12.5,12.5,0,0,0-8.316,11.771V29a4.175,4.175,0,0,1-4.158,4.167A4.175,4.175,0,0,0,6,37.333v8.333H18.474a8.316,8.316,0,1,0,16.632,0h8.316A4.175,4.175,0,0,0,47.58,41.5V33.167ZM26.79,49.833a4.175,4.175,0,0,1-4.158-4.167h8.316A4.175,4.175,0,0,1,26.79,49.833Z",
    transform: "translate(0)",
    fill: "#003765"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationActive);
export default __webpack_public_path__ + "static/media/notification-active.dfba558c08222e2f1efafa7f0031f827.svg";
export { ForwardRef as ReactComponent };